/* istanbul ignore file */
import Approval from './Approval';

export default Approval;
